"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  Container: true,
  Ctas: true
};
exports.Ctas = exports.Container = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _LexusTypography = require("../../../LexusTypography");
var _breakpoints = _interopRequireDefault(require("../../../breakpoints"));
var BaseStyles = _interopRequireWildcard(require("../index.styled"));
Object.keys(BaseStyles).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === BaseStyles[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return BaseStyles[key];
    }
  });
});
const Container = exports.Container = _styledComponents.default.div`
  ${(0, _LexusTypography.nobel)({
  weight: "regular",
  sizing: "body14"
})}
  display: flex;
  flex-direction: column;
  text-align: center;
  flex: 1 1 100%;
  max-width: 100%;

  ${(0, _breakpoints.default)("tablet", "up")} {
    flex: 1 1 calc(33% - 32px);
    max-width: calc(33% - 32px);
  }
`;
const Ctas = exports.Ctas = (0, _styledComponents.default)(BaseStyles.Ctas)`
  padding-bottom: 0;
`;